module.exports = require("core-js/modules/es.string.trim.js");